import { type PropsWithChildren } from "react";

import { AnimatePresence, motion } from "framer-motion";
import { twMerge } from "tailwind-merge";

import { BUDGET_MIX_WIDTH_WITH_CHART } from "../budget-mix-chart/constants";

export function CardWrapper({
  children,
  className,
  topBarColor = "#E0E2E6",
}: PropsWithChildren<{
  className?: string;
  topBarColor?: string;
}>) {
  return (
    <AnimatePresence>
      <motion.div
        className={twMerge(
          "card border border-v2-secondary bg-v2-primary rounded-xl flex justify-center items-center relative overflow-hidden",
          className,
        )}
        style={{ width: `${BUDGET_MIX_WIDTH_WITH_CHART}px` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2, ease: "easeIn" }}
      >
        <div
          className="h-2 rounded-t-xl absolute top-0 left-0 right-0 border border-t-0 border-b-0 border-inherit"
          style={{ backgroundColor: topBarColor }}
        />
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
